export default __webpack_public_path__ + "static/media/contacts.5a1bc99e.png";